var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section create-sections" }, [
    _vm.title && _vm.title.length > 0
      ? _c(
          "div",
          { staticClass: "section-header" },
          [
            _c("div", {
              staticClass: "section-mark",
              style: { "border-left-color": _vm.mColor },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _vm.dropdownItems && _vm.dropdownItems.length > 0
              ? _c(
                  "el-dropdown",
                  {
                    staticClass: "create-sections__more",
                    attrs: { trigger: "click" },
                    on: { command: _vm.handleTypeClick },
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-more",
                      staticStyle: { cursor: "pointer" },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      _vm._l(_vm.dropdownItems, function (item, index) {
                        return _c(
                          "el-dropdown-item",
                          {
                            key: index,
                            attrs: { icon: item.icon, command: item.command },
                          },
                          [_vm._v(_vm._s(item.label))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._t("header"),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content create-sections-content" },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }